"use strict";

module.exports = {
    "ada_back": "reculer",
    "ada_cancel": "Annuler",
    "ada_close_modal": "cerrar",
    "ada_escape_to_close": "Appuyez sur Échappement pour fermer",
    "ada_favorite": "Favoris",
    "ada_find_enter_to_select": "Appuyez sur Entrée pour sélectionner",
    "ada_find_filter_freestyle": "Coca-cola Freestyle",
    "ada_find_search": "Rechercher",
    "ada_find_search_enter": "Appuyez sur Entrée pour rechercher",
    "ada_find_search_text": "Entrez la ville et la province ou le territoire, ou le code postal pour trouver un restaurant Wendy’s",
    "ada_find_search_your_location": "Chercher les restaurants Wendy’s les plus près de votre emplacement",
    "ada_kilometers": "Kilomètres",
    "ada_limited_time_offer": "Offre d’une durée limitée",
    "ada_miles": "Miles",
    "ada_space_to_toggle": "Appuyez sur la barre d’espacement pour basculer",
    "amenities_always_open": "Ouvert 24 heures",
    "amenities_breakfast": "Déjeuner",
    "amenities_freestyle": "Coca-Cola Freestyle©",
    "amenities_mobile_order": "Commande par téléphone mobile",
    "amenities_mobile_pay": "Fonction Mobile Payment",
    "amenities_open_late": "Ouvert tard",
    "card_hours_open": "Ouvert: ",
    "amenities_wifi": "Wi-Fi",
    "common_login_and": "et",
    "common_login_cookies": "Les Témoins et les technologies de suivi",
    "common_login_does_not_match": "Ne correspond pas",
    "common_login_dont_have": "Vous n’avez pas de compte?",
    "common_login_email_address": "Adresse électronique",
    "common_login_email_placeholder": "Connectez-vous comme",
    "common_login_email_verification_message": "Confirmation de votre adresse courriel. Très bien! Connectez-vous et trouvez quelque chose de délicieux.",
    "common_login_forgot_password": "Mot de passe oublié",
    "common_login_invalid_email": "Adresse courriel non valide",
    "common_login_login_with": "Connectez-vous avec",
    "common_login_name_email_error": "L’adresse courriel et le mot de passe ne correspondent pas à nos données inscrites. Veuillez essayer de nouveau.",
    "common_login_privacy_policy": "Politique De Confidentialité",
    "common_login_read_our": "Lisez nos",
    "common_login_required": "Requis",
    "common_login_reset": "RÉINITIALISER",
    "common_login_reset_message": "Réinitialisez le mot de passe pour le compte Wendy’sMD",
    "common_login_reset_password": "Réinitialisez le mot de passe",
    "common_login_show_all": "Montrer toutes les options pour se connecter",
    "common_login_show_options": "Montrer toutes les options pour se connecter",
    "common_login_sign_up": "Inscrivez-vous",
    "common_login_submit_button": "Soumettre",
    "common_login_terms_of": "conditions d’utilisation",
    "common_login_title": "Se Connecter",
    "common_login_welcome_back": "Bon retour",
    "common_login_with": "Ou connectez-vous avec",
    "comp_LoginModal_ContinueAsGuest": "Continuer en tant qu'invité",
    "comp_LoginModal_CreateAccount_ContinueAsGuest": "Continuer en tant qu'invité",
    "comp_LoginModal_CreateAccount_Email_placeholder": "Courriel",
    "comp_LoginModal_CreateAccount_FirstName_placeholder": "Prénom",
    "comp_LoginModal_CreateAccount_LastName_placeholder": "Nom de famille",
    "comp_LoginModal_CreateAccount_OptIn": "Je souhaiterais recevoir occasionnellement des promotions de Wendy's.",
    "comp_LoginModal_CreateAccount_Password_placeholder": "Mot de passe",
    "comp_LoginModal_CreateAccount_RegistryWith": "Ou s'inscrire sur",
    "comp_LoginModal_CreateAccount_SecurityQuestionAnswer_placeholder": "Réponse à la question de sécurité",
    "comp_LoginModal_CreateAccount_Signup_button": "Se connecter",
    "comp_LoginModal_CreateAccount_SubText": "Entrez les renseignements demandés pour créer un compte numérique Wendy’s®.",
    "comp_LoginModal_CreateAccount_SubText_Loyalty": "Entrez les renseignements demandés pour créer un compte numérique Wendy’s®, puis inscrivez-vous au programme de Wendy’s Rewards™.",
    "comp_LoginModal_CreateAccount_TOC": "Conditions d’utilisation",
    "comp_LoginModal_CreateAccount_TOC_first": "Lisez nos",
    "comp_LoginModal_CreateAccount_TOS": "conditions d'utilisation",
    "comp_LoginModal_CreateAccount_TOS_first": "J'accepte les",
    "comp_LoginModal_Email_placeholder": "Saisir l'adresse de courriel",
    "comp_LoginModal_ForgotPassword": "Mot de passe oublié?",
    "comp_LoginModal_Login_button": "Connexion",
    "comp_LoginModal_OrLoginWith": "Ou se connecter avec",
    "comp_LoginModal_Password_placeholder": "Mot de passe",
    "comp_LoginModal_createAccount_button": "Créer un compte",
    "comp_LoginModal_forgotPassword_cancel_button": "Annuler",
    "comp_LoginModal_forgotPassword_email_address_placeholder": "Adresse électronique",
    "comp_LoginModal_forgotPassword_first_step_description": "Entrez votre adresse de messagerie dans le champ ci-dessous et cliquez sur Soumettre.",
    "comp_LoginModal_forgotPassword_header": "Mot de passe oublié",
    "comp_LoginModal_forgotPassword_securityQuestion_description": "Répondez à la question de sécurité suivante et cliquez sur « Réinitialiser ».",
    "comp_LoginModal_forgotPassword_securityQuestion_done_button": "Réinitialiser",
    "comp_LoginModal_forgotPassword_securityQuestion_input_placeholder": "Réponse à la question de sécurité",
    "comp_LoginModal_forgotPassword_submit_button": "Soumettre",
    "comp_LoginModal_header": "Se connecter ou créer un compte",
    "comp_LoginModal_login_button": "Se connecter",
    "easy_as": "Aussi simple que ça",
    "email_sign_up": "Inscrivez-vous",
    "email_sign_up_confirm_password": "Confirmez le mot de passe",
    "email_sign_up_does_not_match": "Ne Correspond Pas",
    "email_sign_up_email_address": "Adresse électronique",
    "email_sign_up_first_name": "Prénom",
    "email_sign_up_invalid_postal": "Code postal non valide",
    "email_sign_up_last_name": "Nom de famille",
    "email_sign_up_need_info": "Il nous faut seulement quelques renseignements de plus pour terminer votre inscription.",
    "email_sign_up_need_info_loyalty": "Entrez les renseignements demandés pour créer un compte numérique Wendy’s, puis inscrivez-vous au programme de récompenses Wendy’s.",
    "email_sign_up_need_postal": "Inscrivez votre code postal pour ne manquer aucune offre exceptionnelle",
    "email_sign_up_page_title": "Inscrivez-vous par courriel",
    "email_sign_up_password": "Mot de passe",
    "email_sign_up_postal_code": "Code postal",
    "email_sign_up_zip_code": "Code postal",
    "email_sign_up_security_question": "Question de sécurité",
    "email_sign_up_security_question_answer": "Réponse à une question de sécurité",
    "email_sign_up_select_security_question": "Sélectionnez une question de sécurité",
    "email_sign_up_zip_desc": "Cela nous aide à vous proposer des offres et des produits offerts exclusivement dans votre région.",
    "email_sign_up_submit_error": "Tous les champs sont requis.",
    "email_sign_up_country": "Pays",
    "email_sign_up_currency": "Monnaie",
    "email_sign_up_country_description": "Détermine les articles du menu à afficher et le format du texte.",
    "email_sign_up_currency_description": "Inscrivez de façon permanente la monnaie numérique associée à votre compte",
    "email_terms_text1": "En cliquant sur « Se connecter », vous acceptez les ",
    "email_terms_text2": "conditions générales",
    "flag_selector_title": "Inscrivez-vous par courriel",
    "flag_selector_description": "Sélectionnez votre pays. Cela nous permet de savoir quels choix de menu afficher et la façon de formater le texte en fonction de votre pays.",
    "flag_selector_us_flag": { id: 1, value: "États-Unis", postValue: 'US' },
    "flag_selector_ca_flag": { id: 2, value: "Canada", postValue: 'CA' },
    "email_verification_step1_title_1": "Vérifiez ",
    "email_verification_step1_title_2": "vos courriels ",
    "email_verification_step1_title_3": "vous devriez avoir reçu un message de Wendy’s.",
    "email_verification_step2_title_1": "Cliquez sur ",
    "email_verification_step2_title_2": "le bouton ",
    "email_verification_step2_title_3": "pour confirmer votre adresse de courriel.",
    "email_verification_title": "Nous avons presque terminé. Encore une ou deux choses…",
    "find_buttons_get_directions": "Obtenez un itinéraire",
    "find_buttons_select": "Sélectionner",
    "footer_about_us": "À propos de Wendy's",
    "footer_bottom_contact": "CONTACT",
    "footer_buy_cards": "",
    "footer_careers": "Carrières",
    "footer_check_card_balance": "Vérifiez solde de la carte",
    "footer_community": "COMMUNAUTÉ",
    "footer_contact": "Contact",
    "footer_cookie": "Les Témoins Et Les Technologies De Suivi",
    "footer_copyright": "© 2017 Quality Is Our Recipe, LLC",
    "footer_dave_thomas_foundation": "La fondation pour l'adoption Dave Thomas",
    "footer_get_app": "TÉLÉCHAGEZ L'APPLICATION MON WENDY'S(MC)",
    "footer_international": "International",
    "footer_investors": "Investisseurs",
    "footer_locations": "Restaurants",
    "footer_mailing_address": "5515 North Service Road, Suite 201, Burlington, Ontario, Canada L7L 6G4",
    "footer_news": "Actualités",
    "footer_nutrition_information": "Information Nutritionnelle",
    "footer_our_company": "WENDY'S EN GÉNÉRAL",
    "footer_payment_incident": "Mises à jour sur les incidents liés aux cartes de paiement",
    "footer_privacy": "Politique De Confidentialité",
    "footer_quick_links": "QUICK LINKS",
    "footer_responsibility": "Responsibilité",
    "footer_sign_up_for_my_wendys": "",
    "footer_sitemap": "PLAN DU SITE",
    "footer_stay_connected": "SOYEZ AU COURANT",
    "footer_terms": "Conditions D’Utilisation",
    "footer_unsubscribe": "Se désabonner",
    "footer_wendys_gives_back": "",
    "footer_wendys_high_school_heisman": "",
    "footer_wendys_wonderful_kids": "",
    "header_about_us": "À NOTRE SUJET",
    "header_careers": "PERSPECTIVES",
    "header_feedback": "COMMENTAIRES",
    "header_menu_image_1": "/images/nav/fr_CA/dine-men-1.png",
    "header_menu_image_2": "/images/nav/fr_CA/dine-men-2.png",
    "header_menu_image_3": "/images/nav/fr_CA/dine-men-3.png",
    "header_menu_image_4": "/images/nav/fr_CA/dine-men-4.png",
    "header_menu_image_5": "/images/nav/fr_CA/dine-men-5.png",
    "header_menu_image_6": "/images/nav/fr_CA/dine-men-6.png",
    "header_menu_image_7": "/images/nav/fr_CA/dine-men-7.png",
    "header_menu_image_8": "/images/nav/fr_CA/dine-men-8.png",
    "header_menu_image_cta": "/images/nav/fr_CA/dine-men-cta.jpeg",
    "header_menu_link_1": "https://www.wendys.com/fr-ca/hamburgers",
    "header_menu_link_2": "https://www.wendys.com/fr-ca/chicken",
    "header_menu_link_3": "https://www.wendys.com/fr-ca/salads",
    "header_menu_link_4": "https://www.wendys.com/fr-ca/right-price-right-size",
    "header_menu_link_5": "https://www.wendys.com/fr-ca/fries-sides",
    "header_menu_link_6": "https://www.wendys.com/fr-ca/beverages",
    "header_menu_link_7": "https://www.wendys.com/fr-ca/kids-meals",
    "header_menu_link_8": "https://www.wendys.com/fr-ca/frosty",
    "header_menu_link_cta": "https://www.wendys.com/fr-ca/pair-2",
    "header_menu_text_1": "HAMBURGERS CARRÉMENT BON",
    "header_menu_text_2": "POULET ET WRAPS",
    "header_menu_text_3": "SALADES SENSATIONS DU JARDIN",
    "header_menu_text_4": "MENU VALEUR TOUS LES JOURS",
    "header_menu_text_5": "FRITES ET PLATS D’ACCOMPAGNEMENT",
    "header_menu_text_6": "BOISSONS",
    "header_menu_text_7": "REPAS POUR ENFANT WENDY’S",
    "header_menu_text_8": "FROSTY (MC)",
    "header_nav_learn_meal_builder_link": "https://www.wendys.com/fr-ca/meal-builder",
    "header_title_main_link": "/images/common/QIOR.fr_CA.png",

    "header_title_text_find": "TROUVEZ",
    "header_title_text_learn": "DÉCOUVREZ",
    "header_title_text_menu": "MANGEZ",
    "header_title_text_my": "MON WENDY'S",
    "header_title_text_order": "COMMANDER",
    "header_title_text_play": "JOUEZ",
    "language_select_canadian_english": "Anglais Canada",
    "language_select_canadian_french": "Français Canada",
    "language_select_english": "Anglais É.-U.",
    "language_select_spanish": "Espagnol É.-U.",
    "location_page_filter_breakfast": "Déjeuner",
    "location_page_filter_clear": "Effacer",
    "location_page_filter_coke_freestyle": "Coca-Cola Freestyle©",
    "location_page_filter_done": "Terminé",
    "location_page_filter_is_favorite": "Favoris",
    "location_page_filter_mobile_ordering": "Commande par téléphone mobile",
    "location_page_filter_mobile_payment": "Fonction Mobile Payment",
    "location_page_filter_open_24_hours": "Ouvert 24 heures",
    "location_page_filter_open_late": "Ouvert tard",
    "location_page_filter_title": "Options de filtre",
    "location_page_filter_wifi": "Wi-Fi",
    "location_page_find_location_title": "Trouver un restaurant",
    "location_page_open_today": "Ouvert",
    "maybe_later": "Passer cette étape",
    "notification_geo_failed_text": "Il nous est impossible d'obtenir votre emplacement. Veuillez entrer votre emplacement dans le champ de recherche.",
    "notification_geo_failed_title": "Un problème est survenu pendant la recherche de votre emplacement",
    "notification_modal_failure_text": "Un problème est survenu, réessayez ultérieurement.",
    "notification_modal_failure_title": "Un problème est survenu",
    "notification_modal_success_text": "Nous vous remercions de l'intérêt que vous portez à notre boutique en ligne. Nous vous informerons dès que ce restaurant pourra prendre vos commandes.",
    "notification_modal_success_title": "Merci!",
    "notify_buttons_email_me": "Contactez-moi par courriel",
    "order_buttons_order_here": "Commander ici",
    "payment_options_account_created": "Le compte a été créé",
    "payment_options_add_card": "Ajouter carte",
    "payment_options_add_funds": "Ajouter de l'argent",
    "payment_options_add_new_card": "Ajouter une nouvelle carte",
    "payment_options_are_you_sure_remove": "Êtes-vous sûr(e) de vouloir supprimer cette carte?",
    "payment_options_auto_reload": "Transfert automatique",
    "payment_options_credit_card": "CARTE DE CRÉDIT",
    "payment_options_curious_about_mobile": "Vous voulez en savoir plus sur le paiement mobile?",
    "payment_options_go_to_transaction_history": "Aller à Historique des transactions",
    "payment_options_grab_the_app_link_text": "Munissez-vous de l'appli!",
    "payment_options_masked_credit_card": "se terminant en",
    "payment_options_mobile_payment_app_explanation": "Le paiement mobile est disponible sur l'application Mon Wendy's dans certains restaurants participants. Remarque : Votre compte peut comporter une somme maximale de 100 $.",
    "payment_options_my_balance": "Mon solde",
    "payment_options_no": "Non",
    "payment_options_no_recent": "Aucune activité récente",
    "payment_options_no_saved_card": "Pas de carte enregistrée",
    "payment_options_close": "Fermer",
    "payment_options_payment_settings": "Options de paiement",
    "payment_options_recent_activity": "Activité récente",
    "payment_options_remove": "Supprimer",
    "payment_options_remove_your_card": "Supprimer votre carte?",
    "payment_options_replace": "Remplacer",
    "payment_options_replace_card": "Remplacer votre carte?",
    "payment_options_replace_card_explanation_text": "Êtes-vous sûr(e) de vouloir remplacer cette carte? Si vous cliquez sur « Oui », vous supprimerez la carte de votre compte, même si vous n'avez pas terminé le processus d'ajout de la nouvelle carte.",
    "payment_options_wendys_digital_account": "COMPTE NUMÉRIQUE WENDY'S",
    "payment_options_yes": "Oui",
    "product_tile_selected": "choisi",
    "promo_item_limited_time_offer": "LIMITED TIME OFFER",
    "rewards_back": "Retour",
    "rewards_change": "Cambiar",
    "rewards_choose": "Choisissez",
    "rewards_choose_your_reward": "Choisissez votre récompense",
    "rewards_choose_your_reward_subtitle": "Gagnez la récompense que vous désirez. Vous pourrez toujours la changer à partir de la page Compte.",
    "rewards_done_button": "Terminé",
    "rewards_enrollment_disclaimer": "*Gratuitement avec une inscription achevée aux Récompenses Wendy’s. Obtenez des points et échangez-les contre des récompenses seulement avec les commandes mobiles dans les restaurants Wendy'sMD participants. La mise à jour des points de récompense peut prendre jusqu’à 24 heures.",
    "rewards_free_single": "OBTENEZ UN SIMPLE DE DAVEMD GRATUIT",
    "rewards_join_button": "Inscription aux récompenses",
    "rewards_join_button_join": "S’inscrire",
    "rewards_join_choose_reward": "Choisissez votre récompense",
    "rewards_join_choose_reward_hint": "Choisissez la récompense que vous souhaitez obtenir. Vous pouvez changer votre récompense en tout temps à partir de la page Compte.",
    "rewards_join_coming_soon_body": "Patientez un instant, nous sommes encore en train de préparer la recette parfaite des Récompenses. Vous serez la première personne informée lorsqu’elle sera prête.",
    "rewards_join_coming_soon_title": "Des récompenses seront offertes prochainement!",
    "rewards_join_loyalty_card_hint": "Si vous avez une carte de récompense, saisissez le numéro ici afin que nous puissions ajouter tous vos points accumulés au restaurant.",
    "rewards_join_loyalty_card_label": "Saisissez votre numéro de carte",
    "rewards_join_loyalty_card_placeholder": "Numéro à l'endos de la carte",
    "rewards_join_loyalty_card_toggle_copy": "J'ai reçu une carte dans un restaurant.",
    "rewards_join_loyalty_card_toggle_hint": "Vous n'avez pas de carte? Sautez cette étape!",
    "rewards_join_loyalty_card_toggle_label": "Avez-vous une carte de récompenses?",
    "rewards_join_phone_hint": "Votre numéro de téléphone est aussi votre numéro de carte de récompenses Wendy’s RewardsMC.",
    "rewards_join_phone_label": "Saisissez votre numéro de téléphone",
    "rewards_join_phone_placeholder": "e.g. 123 456 7890",
    "rewards_join_postal_hint": "Les récompenses sont offertes dans certains restaurants. Regardez si elles sont disponibles dans votre région.",
    "rewards_join_postal_label": "Saisissez votre code postal",
    "rewards_join_postal_placeholder": "e.g. 23456",
    "rewards_join_title": "Inscription au programme de récompenses de Wendy’s",
    "rewards_join_value_prop": "Inscrivez-vous au programme de récompenses de Wendy’s et gagnez 1 point pour chaque dollar dépensé. C’est simple.",
    "rewards_join_value_prop2": "Saisissez votre numéro de téléphone pour terminer votre inscription au programme de récompenses.",
    "rewards_join_value_prop3": "Obtenez 1 point pour chaque 1 $ dépensé",
    "rewards_join_value_prop4": "sur les commandes mobiles dans les restaurants Wendy’sMD participants",
    "rewards_join_value_prop_available": "Inscrivez-vous pour commencer à accumuler des points.",
    "rewards_join_value_prop_step1": "Entrez 5 chiffres pour obtenir des aliments gratuits.",
    "rewards_join_value_prop_unavailable": "Les choses gratuites arrivent à ceux qui savent attendre.",
    "rewards_join_value_prop_with_purchase": "avec tout achat sur votre prochaine commande mobile!",
    "rewards_join_wendymail_body": "Je veux recevoir un courriel de Wendy’s et être avisé(e) lorsque le programme de récompenses sera lancé dans ma région,",
    "rewards_next_button": "Suivant",
    "rewards_not_now": "Pas maintenant",
    "rewards_one": "UN",
    "rewards_one_text": "Inscrivez-vous au programme de récompenses, choisissez votre récompense et savourez un « Dave’s Single »!",
    "rewards_points": "points",
    "rewards_points_needed": "points requis",
    "rewards_skip_button": "Passer les récompenses",
    "rewards_step2_title": "Étape 2 : ",
    "rewards_terms_and_conditions": "Conditions d’utilisation concernant les récompenses.",
    "rewards_terms_and_conditions_preface": "En cochant cette case, j’accepte les ",
    "rewards_three": "GRATUIT",
    "rewards_three_text": "Dès que vous avez assez de points, nous vous envoyons votre récompense. Vous pouvez obtenir autant de récompenses que vous le souhaitez!",
    "rewards_three_title": "Obtenez de la nourriture gratuite",
    "rewards_two": "DEUX",
    "rewards_two_text": "Chaque achat Wendy’s vous donne des points à échanger contre la récompense de votre choix.",
    "rewards_two_title": "Gagnez des points",
    "rewards_when_enroll": "lorsque vous vous inscrivez.",
    "rewards_yours_now": "Pour vous, dès maintenant",
    "search_container_mobile_pay": "Fonction Mobile Pay (paiement mobile)",
    "search_container_mobile_ordering": "Commande par téléphone mobile",
    "search_container_breakfast": "Déjeuner",
    "search_container_free_style": "Coca-Cola Freestyle©",
    "search_container_digital_coupon": "Coupon numérique",
    "search_container_open_late": "Ouvert tard",
    "search_container_24_hours": "Ouvert 24 heures",
    "search_container_wifi": "Wifi",
    "search_container_hola": "Hola",
    "search_container_loyalty": "Loyalty",
    "search_container_mcx": "MCX",
    "search_container_cso": "CSO",
    "search_container_list": "Liste",
    "search_container_location_entry_placeholder": "Entrez ville/ province/ code postal",
    "search_container_locations_found": "RESTAURANTS TROUVÉS",
    "search_container_map": "Carte",
    "search_container_no_results_message": "Aucun résultat trouvé, suggestions de recherche",
    "search_container_results_found": "Aucun résultat trouvé",
    "search_container_search": "Rechercher",
    "search_container_searching": "Recherche",
    "search_result_open": "Ouvert",
    "search_results_no_loc": "Il n’existe aucun restaurant Wendy’s dans un rayon de 40 kilomètres (25 miles) de votre emplacement.",
    "search_results_no_mobile_desc": "La fonction de commande mobile peut ne pas encore être offerte dans votre zone, mais ne vous inquiétez pas! Visitez l’un de nos restaurants près de votre emplacement.",
    "search_results_on_our_way": "Nous y sommes presque!",
    "search_results_too_many_filters": "Veuillez retirer quelques filtres pour effectuer une recherche un peu plus générique.",
    "selected_result_close": "Fermer",
    "times_not_available": "Les temps ne sont pas disponibles",
    "value_proposition_caption": "Avez-vous faim?",
    "value_proposition_caption_img1_text_1": "Parcourez le site de Wendy’s pour prendre",
    "value_proposition_caption_img1_text_2": "connaissance des nouveaux produits du menu",
    "value_proposition_caption_img2_text_1": "Obtenez les informations nutritionnelles",
    "value_proposition_caption_img2_text_2": "que vous recherchez",
    "value_proposition_caption_img3_text_1": "Inscrivez-vous et économisez à l’achat",
    "value_proposition_caption_img3_text_2": "de vos mets préférés",
    "value_proposition_login_text1": "Already have an account? ",
    "value_proposition_login_text2": "Se Connecter",
    "value_proposition_sign_up_email": "Inscrivez-vous avec votre courriel",
    "value_proposition_sign_up_facebook": "Inscrivez-vous avec Facebook",
    "value_proposition_sign_up_google": "Inscrivez-vous avec Google",
    "delivery_search_title": "Get It Delivered",
    "delivery_search_body": "Get all your Wendy's favorites delivered right to your door.",
    "delivery_search_button": "Go to Delivery",
    "delivery_search_loading": "Chargement"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/fr_CA.js
// module id = 189
// module chunks = 0